import { UserProfile } from 'src/interfaces/user';

export const getPermissions = (
  userProfile: UserProfile | null,
  brandSecurity: Record<string, any> | null,
  clientType: string,
) => {
  let brandCommonRoles =
    clientType === 'Brand'
      ? userProfile?.dash?.brands?.brandCommonRoles
      : userProfile?.dash?.locations?.locationCommonRoles;
  let permissions = {};
  let isbrandAdminRole = false;
  if (!brandCommonRoles) {
    brandCommonRoles =
      clientType === 'Brand'
        ? userProfile?.dash?.brands?.brandList[userProfile.dash.activeBrand]
        : userProfile?.dash?.locations?.locationList[
            userProfile.dash.activeLocationPartner
          ];
  }
  if (!brandCommonRoles) {
    return {
      permissions,
      isbrandAdminRole,
      superAdmin: userProfile?.dash.superAdmin ?? false,
    };
  }
  let commonRoleKeys: string[] = Object.keys(brandCommonRoles);

  if (brandSecurity && brandSecurity.roles) {
    commonRoleKeys.map((key) => {
      const element = brandCommonRoles[key];
      if (element) {
        isbrandAdminRole = brandSecurity.roles[key].isAdminRole;
        if (!isbrandAdminRole)
          permissions = { ...brandSecurity.roles[key].permissions };

        //console.log(brandSecurity.roles[key]);
      }
    });
  }
  return {
    permissions,
    isbrandAdminRole,
    superAdmin: userProfile?.dash.superAdmin ?? false,
  };
};
